module.exports = __webpack_public_path__ + "static/media/biuro1.9c3e737a.jpg";